/**
 * OMNI Home Personalized: Recently Viewed + Recommended
 * "壊れない実装" - section_id方式に統一、.json取得を全廃
 */
(function () {
  const KEY = 'omni_rv_v1';
  const root = document.querySelector('.omni-home-personalized');
  if (!root) return;

  const recentBlock = root.querySelector('[data-omni-block="recent"]');
  const recBlock = root.querySelector('[data-omni-block="recommended"]');

  const recentList = root.querySelector('[data-omni-list="recent"]');
  const recList = root.querySelector('[data-omni-list="recommended"]');

  const recentSkel = root.querySelector('[data-omni-skeleton="recent"]');
  const recSkel = root.querySelector('[data-omni-skeleton="recommended"]');

  const MAX_RECENT = 8;
  const MAX_RECOMMENDED = 8;

  // ===== Utility Functions =====
  function safeParse(raw) { 
    try { 
      return JSON.parse(raw); 
    } catch(e) { 
      return null; 
    } 
  }
  
  function hide(el) { 
    if (el) el.hidden = true; 
  }
  
  function show(el) { 
    if (el) el.hidden = false; 
  }
  
  function remove(el) { 
    if (el && el.parentNode) el.parentNode.removeChild(el); 
  }

  // ===== Core Functions (壊れない実装) =====

  /**
   * localStorageからhandle配列を取得（安全）
   */
  function getRecentlyViewedHandles(limit = 12) {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    
    try {
      const data = JSON.parse(raw);
      const arr = Array.isArray(data) ? data : (data?.items || []);
      return arr
        .map(v => (typeof v === 'string' ? v : v?.handle))
        .filter(Boolean)
        .slice(0, limit);
    } catch {
      return [];
    }
  }

  /**
   * section_id方式でHTMLを取得（.json廃止）
   */
  async function fetchProductCardHTML(handle, sectionId = 'omni-product-card') {
    try {
      const res = await fetch(`/products/${encodeURIComponent(handle)}?section_id=${sectionId}`, { 
        credentials: 'same-origin' 
      });
      if (!res.ok) return null;
      return await res.text();
    } catch (e) {
      console.warn(`[omni-home] fetch failed: ${handle}`, e);
      return null;
    }
  }

  /**
   * HTMLからliを取り出してappendする（重複/除外セットに対応）
   */
  function appendLis(targetUl, htmlText, { excludeHandles, seenHandles, maxAdd }) {
    if (!htmlText || !targetUl) return { added: 0, addedHandles: [] };

    const tmp = document.createElement('div');
    tmp.innerHTML = htmlText.trim();

    const lis = Array.from(tmp.querySelectorAll('li'));
    let added = 0;
    const addedHandles = [];

    for (const li of lis) {
      if (added >= maxAdd) break;

      const handle = li.dataset && li.dataset.productHandle ? li.dataset.productHandle : null;
      if (!handle) continue;

      if (excludeHandles && excludeHandles.has(handle)) continue;
      if (seenHandles && seenHandles.has(handle)) continue;

      // mark seen
      if (seenHandles) seenHandles.add(handle);

      targetUl.appendChild(li.cloneNode(true));
      added++;
      addedHandles.push(handle);
    }

    return { added, addedHandles };
  }

  /**
   * 最近閲覧を描画（for-of方式、shift廃止）
   */
  async function loadRecentlyViewed(handles) {
    if (!recentList) return { count: 0, shownHandles: new Set() };

    const seen = new Set();
    const shownHandles = new Set();
    let shown = 0;

    console.log('[omni-home] loadRecentlyViewed: handles=', handles);

    for (const h of handles) {
      if (shown >= MAX_RECENT) break;

      const html = await fetchProductCardHTML(h, 'omni-product-card');
      if (!html) continue;

      const result = appendLis(recentList, html, {
        excludeHandles: null,
        seenHandles: seen,
        maxAdd: MAX_RECENT - shown
      });

      // 実際に表示できたhandleだけ記録（在庫なしはliが返らず入らない）
      result.addedHandles.forEach(x => shownHandles.add(x));
      shown += result.added;
    }

    console.log('[omni-home] loadRecentlyViewed: shown=', shown);

    return { count: shown, shownHandles };
  }

  /**
   * おすすめ商品を描画
   */
  async function loadRecommended(productId, excludeHandles) {
    if (!recList) return { count: 0 };

    // まず12件くらい取って、JSで除外＆最大8件に絞る
    const url = `/recommendations/products?product_id=${encodeURIComponent(productId)}&limit=12&intent=related&section_id=omni-recommended-cards`;
    
    let html;
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return { count: 0 };
      html = await res.text();
    } catch (e) {
      console.warn('[omni-home] recommendations fetch failed', e);
      return { count: 0 };
    }

    const seen = new Set(); // おすすめ内重複排除
    const result = appendLis(recList, html, {
      excludeHandles,
      seenHandles: seen,
      maxAdd: MAX_RECOMMENDED
    });

    console.log('[omni-home] loadRecommended: added=', result.added);

    return { count: result.added };
  }

  /**
   * 初期化
   */
  async function init() {
    try {
      // 初回訪問は完全非表示（headフラグが付かないはずだが、念のためJSでも判定してremove）
      let data;
      try {
        const raw = localStorage.getItem(KEY);
        if (!raw) { 
          console.log('[omni-home] no localStorage data');
          remove(root); 
          return; 
        }
        data = safeParse(raw);
        if (!data || !Array.isArray(data.items) || data.items.length === 0) { 
          console.log('[omni-home] empty or invalid data');
          remove(root); 
          return; 
        }
      } catch (e) { 
        console.warn('[omni-home] localStorage parse error', e);
        remove(root); 
        return; 
      }

      console.log('[omni-home] init: data.items.length=', data.items.length);

      // 表示対象ユーザーだけ：ブロックを出し、スケルトン表示開始
      show(recentBlock);
      show(recBlock);

      // 実カードは空のまま、スケルトンを見せる
      show(recentSkel);
      show(recSkel);

      const handles = getRecentlyViewedHandles(12);
      console.log('[omni-home] handles=', handles);

      // 1) 最近閲覧
      const recentResult = await loadRecentlyViewed(handles);
      if (recentResult.count === 0) {
        // 0件ならブロックごと隠す
        hide(recentSkel);
        remove(recentSkel);
        hide(recentBlock);
      } else {
        hide(recentSkel);
        remove(recentSkel);
      }

      // 2) おすすめ（閲覧と重複除去）
      const lastId = data.last;
      let recCount = 0;
      if (lastId) {
        const recResult = await loadRecommended(lastId, recentResult.shownHandles);
        recCount = recResult.count;
      }
      
      if (!lastId || recCount === 0) {
        hide(recSkel);
        remove(recSkel);
        hide(recBlock);
      } else {
        hide(recSkel);
        remove(recSkel);
      }

      // 両方0ならセクション自体を消す
      if ((recentBlock && recentBlock.hidden) && (recBlock && recBlock.hidden)) {
        remove(root);
      }
    } catch (e) {
      console.error('[omni-home] init failed', e);
      remove(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
